import React, { useEffect, useMemo, useState } from 'react';
import { fetchAiRates } from '../services/api';

/**
 * Stock-ticker style scrolling bar shown across the top of the site.
 * Displays the weekly input/output token rates (USD per 1M tokens) for the
 * current models of Claude, Gemini, Grok, and ChatGPT Codex.
 */
export default function TokenRateTicker() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchAiRates().then(d => { if (alive) setData(d); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  const items = useMemo(() => {
    if (!data?.rates?.length) return [];
    return data.rates.map((r, i) => (
      <span key={i} className="ticker-item" data-testid={`ticker-item-${i}`}>
        <strong>{r.provider} {r.model}</strong>
        <span className="ticker-in">in ${Number(r.input_per_mtok).toFixed(2)}</span>
        <span className="ticker-out">out ${Number(r.output_per_mtok).toFixed(2)}</span>
        <span className="ticker-unit">/1M tok</span>
        <span className="ticker-sep">◆</span>
      </span>
    ));
  }, [data]);

  if (!items.length) return null;

  return (
    <div className="token-ticker" data-testid="token-rate-ticker" role="marquee"
      aria-label="Weekly AI token rates">
      <span className="ticker-label" data-testid="ticker-week-label">
        AI TOKEN RATES · WEEK OF {data.week_of}
      </span>
      <div className="ticker-viewport">
        {/* Track content is duplicated so the loop is seamless. */}
        <div className="ticker-track">
          <div className="ticker-group">{items}</div>
          <div className="ticker-group" aria-hidden="true">{items}</div>
        </div>
      </div>
    </div>
  );
}
